module.exports = __webpack_public_path__ + "img/bg4.4c556799.png";